<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="contact"
    :close-on-press-escape="contact"
    :show-close="contact"
    width="40%"
    top="15vh"
    append-to-body
    class="calling-modal"
    @close="onClose"
  >
    <el-form ref="callingForm" :model="formData" :rules="rules">
      <el-row v-if="contact" type="flex" align="middle">
        <el-col :span="12">
          <p><b>Тип звонка</b></p>
        </el-col>
        <el-col :span="12" class="ta-r">
          <el-select v-model="outgoing" placeholder="Выберите из списка">
            <el-option
              v-for="(st, i) in callTypes"
              :key="i"
              :label="st"
              :value="i"
            />
          </el-select>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <el-row v-if="+outgoing" type="flex" align="middle">
          <el-col :span="12">
            <p><b>Статус звонка</b></p>
          </el-col>
          <el-col :span="12" class="ta-r">
            <el-form-item prop="status">
              <el-select
                v-model="formData.status"
                placeholder="Выберите из списка"
              >
                <el-option
                  v-for="(st, i) in callStatuses"
                  :key="i"
                  :label="st"
                  :value="i"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-transition>
      <el-row class="textarea">
        <el-form-item prop="comment">
          <el-input v-model="formData.comment" :rows="5" type="textarea" />
        </el-form-item>
      </el-row>
      <el-row class="ta-r">
        <el-button type="primary" :loading="loading" @click="onSave">
          Сохранить
        </el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { callStatuses, callTypes } from '@/views/CallCenter/constants'
import { mapActions } from 'vuex'

const CallCenter = RepositoryFactory.get('callCenter')

export default {
  name: 'CallingModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => {},
    },
    contact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      callStatuses,
      callTypes,
      loading: false,
      outgoing: this.contact ? '0' : '1',
      formData: {
        status: null,
        comment: '',
      },
      rules: {
        status: { required: true, message: 'Выберите статус', trigger: 'blur' },
        comment: {
          required: true,
          message: 'Добавьте описание',
          trigger: 'blur',
        },
      },
    }
  },
  methods: {
    ...mapActions({ fetchContact: 'callCenter/fetchContact' }),
    onSave() {
      this.$refs['callingForm'].validate(valid => {
        if (valid) {
          this.loading = true

          if (!Number(this.outgoing)) {
            this.formData.status = '1'
            this.formData.is_incoming = 1
          }
          CallCenter.postCall({ ...this.info, ...this.formData })
            .then(res => {
              const { data, status } = res

              if (status === 201 && data) {
                this.fetchContact(this.info.contact_id)
                this.onClose()
              }
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        }
      })
    },
    onClose() {
      this.$emit('close')
      this.$refs['callingForm'].resetFields()
    },
  },
}
</script>

<style lang="sass">
.calling-modal
  font-family: Rubik, sans-serif
  .el-dialog__body
    font-size: 16px
    color: #000
    padding: 10px 40px 40px
    .el-button
      font-size: 16px
      font-weight: normal
    button
      width: 200px
      height: 47px
    .el-form-item
      margin-bottom: 0
    .textarea
      margin: 30px 0
</style>
